import React, { useState } from "react";
import "./Navbar.scss";
import { Icon } from "@iconify/react";
import logo from "../../../logo.svg";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const ShowSideBar = () => {
    setShowSidebar(!showSidebar);
    console.log("hell000000", showSidebar);
  };
  return (
    <div className="navbar-conatiner d-flex justify-content-between align-items-center">
      <div className="logo-container d-flex justify-content-between align-items-center">
        <a href="/">
          {" "}
          <img src={logo} alt="" />
        </a>
        {showSidebar ? (
          <>
            <Icon
              icon="maki:cross"
              color="#a874ec"
              width="35"
              height="35"
              onClick={ShowSideBar}
              className="menu-icon"
            />
          </>
        ) : (
          <>
            {" "}
            <Icon
              icon="mingcute:menu-fill"
              color="#a874ec"
              width="35"
              height="35"
              onClick={ShowSideBar}
              className="menu-icon"
            />
          </>
        )}
      </div>

      <div className="nav-menu-container">
        <Link to="/dashboard" className="menuItem">
          Dashboard
        </Link>
        <Link to="" className="menuItem">
          Ranking
        </Link>
        <Link to="" className="menuItem">
          Contact Us
        </Link>
      </div>

      <div className="nav-btns-container">
        <Link to="/login" className="theme-Btn-bg">
          <span>Login</span>
        </Link>
        <Link to="/signup" className="theme-Btn-trans">
          <span>Signup</span>
        </Link>
      </div>

      <div
        className={`nav-mobile-container ${
          showSidebar ? "show-nav-moblie" : ""
        }`}
      >
        <div className="logo-container d-flex justify-content-between w-100 align-items-center">
          <img src={logo} alt="" />
          <Icon
            icon="maki:cross"
            color="#a874ec"
            width="35"
            height="35"
            onClick={ShowSideBar}
          />
        </div>
        <div className="nav-menu-container">
          <Link to="/dashboard" className="menuItem">
            Dashboard
          </Link>
          <Link className="menuItem">Ranking</Link>
          <Link className="menuItem">Contact Us</Link>
        </div>

        <div className="nav-btns-container">
          <Link to="/login" className="theme-Btn-bg">
            <span>Login</span>
          </Link>
          <Link to="/signup" className="theme-Btn-trans">
            <span>Signup</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
